import React from 'react';
import { Box } from '@mui/material';
import moment from 'moment';
import { IKpiAlertPointData } from 'components/report-content/components/kpi-chart/series/getKpiAlert';
import { IKpiTooltipProps } from './index';
import CloseIcon from './CloseIcon';

export default function KpiAlertTooltip({ isSelected, point, onClose }: IKpiTooltipProps) {
    const customData = point.options.custom as IKpiAlertPointData;

    const measurementTime = customData.measurementTime
        ? 'Alert on: ' + moment(customData.measurementTime).format('YYYY-MM-DD')
        : 'Alert';
    //@ts-ignore
    const text: string = point.text ?? '';
    return (
        <Box
            sx={{
                py: 1,
                px: 1.5,
            }}
        >
            <Box
                sx={{ fontWeight: 600, pr: isSelected ? 1.5 : undefined }}
                dangerouslySetInnerHTML={{ __html: measurementTime }}
            />
            {isSelected && <CloseIcon onClose={onClose} />}
            <Box sx={{ pt: 0.5 }} dangerouslySetInnerHTML={{ __html: text }} />
        </Box>
    );
}
